import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckedRunner = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 31.1667L27.5766 39L44 24",
		stroke: "currentColor",
		strokeWidth: 5
	})
});
const ForwardRef = forwardRef(SvgCheckedRunner);
export default ForwardRef;
